import FormTitle from "../../components/helpers/FormTitle";
import { Box, Typography } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { ImportError } from "../../components/real/ImportError";

export const Import = () => {
  return (
    <>
      <FormTitle title="Import accounting files" />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}
        >
          <UploadFile />
          <Typography variant="h6" component="div">
            Latest import made
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}
      >
        <ImportError />
      </Box>
    </>
  );
};
